import { ChevronRight, type LucideIcon } from "lucide-react";
import { type PropsWithChildren, type ReactNode } from "react";
import { cn } from "@/lib/utils";

interface ProfileSettingsListProps extends PropsWithChildren {
  label: string;
}

interface ProfileSettingsRowProps {
  icon: LucideIcon;
  label: string;
  onClick: () => void;
  detail?: ReactNode;
  className?: string;
}

export function ProfileSettingsList({ label, children }: ProfileSettingsListProps) {
  return (
    <section aria-label={label} className="flex flex-col gap-2">
      <h2 className="text-sm font-semibold leading-[21px] text-[#0a0c11]">{label}</h2>
      <div className="divide-y divide-[#dddfe4] overflow-hidden rounded-[28px] border border-[#dddfe4] bg-white">
        {children}
      </div>
    </section>
  );
}

export function ProfileSettingsRow({
  icon: Icon,
  label,
  onClick,
  detail,
  className,
}: ProfileSettingsRowProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "flex min-h-[72px] w-full items-center gap-4 px-6 text-left transition-colors hover:bg-[#fafafa] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[var(--dp-brand-button)]",
        className,
      )}
    >
      <Icon aria-hidden="true" className="h-5 w-5 shrink-0 text-[#5b616d]" />
      <span className="min-w-0 flex-1 text-base font-medium leading-6 text-[#0a0c11]">{label}</span>
      {detail}
      <ChevronRight aria-hidden="true" className="h-5 w-5 shrink-0 text-[#5b616d]" />
    </button>
  );
}
